import { dispatch } from 'store';

import { CmsItemNameType } from '../../types/cms.types';
import { CMS_ACTIONS } from '../action-types/cms.action-types';

interface CmsData {
  data: unknown;
  name: CmsItemNameType;
}

export const saveCmsData = (cmsData: CmsData) => dispatch({ type: CMS_ACTIONS.DATA_SAVED, payload: cmsData });
export const fetchCmsData = (cmsItemName) => dispatch({ type: CMS_ACTIONS.FETCH_DATA_CALL, payload: cmsItemName });

export const saveAllCmsData = (cmsData: unknown) => ({
  type: CMS_ACTIONS.ALL_DATA_SAVED,
  payload: cmsData,
});
